'use client';

import { ListPageInfiniteTable } from '../../../common/ListPageInfiniteTable';
import {
  isInternalAssetsGroupHeaderRow,
  isInternalAssetsSortColumn,
  type InternalAssetGridItem,
  type InternalAssetsGroupHeaderRow,
  type InternalAssetsListMode,
  type InternalAssetsSort,
  type InternalAssetsSortColumn,
  type InternalAssetsTableRow,
} from './internal-assets-table.model';
import { useInternalAssetsTableColumnDefs } from './useInternalAssetsTableColumnDefs';

type InternalAssetsTableProps = {
  mode: InternalAssetsListMode;
  rows: InternalAssetsTableRow[];
  loadMoreRowIndex: number | null;
  sort: InternalAssetsSort;
  sortApplied: boolean;
  collapsedGroupKeys: ReadonlySet<string>;
  isLoading: boolean;
  isFetchingMore: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  onSortChange: (sort: InternalAssetsSort) => void;
  onToggleGroup: (groupKey: string) => void;
  onOpenAsset: (item: InternalAssetGridItem) => void;
};

const getItemRowId = (item: InternalAssetGridItem) => item.rowId;

export function InternalAssetsTable({
  mode,
  rows,
  loadMoreRowIndex,
  sort,
  sortApplied,
  collapsedGroupKeys,
  isLoading,
  isFetchingMore,
  hasMore,
  onLoadMore,
  onSortChange,
  onToggleGroup,
  onOpenAsset,
}: InternalAssetsTableProps) {
  const columnDefs = useInternalAssetsTableColumnDefs({
    mode,
    sortApplied,
    collapsedGroupKeys,
    onToggleGroup,
  });

  return (
    <ListPageInfiniteTable<
      InternalAssetGridItem,
      InternalAssetsGroupHeaderRow,
      InternalAssetsSortColumn
    >
      tableKey={mode}
      columnDefs={columnDefs}
      rows={rows}
      getItemRowId={getItemRowId}
      isGroupHeaderRow={isInternalAssetsGroupHeaderRow}
      loadMoreRowIndex={loadMoreRowIndex}
      sort={sort}
      isSortColumn={isInternalAssetsSortColumn}
      isLoading={isLoading}
      isFetchingMore={isFetchingMore}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      onSortChange={onSortChange}
      onToggleGroup={onToggleGroup}
      onOpenItem={onOpenAsset}
    />
  );
}
